import { temporarilyNotSupport } from '../../utils'

// 打开手Q说说发表界面
export const openQzonePublish = /* @__PURE__ */ temporarilyNotSupport('openQzonePublish')
export const getQQRunData = /* @__PURE__ */ temporarilyNotSupport('getQQRunData')
export const setOfficialDress = /* @__PURE__ */ temporarilyNotSupport('setOfficialDress')
export const setCustomDress = /* @__PURE__ */ temporarilyNotSupport('setCustomDress')
export const updateQQApp = /* @__PURE__ */ temporarilyNotSupport('updateQQApp')
export const addRecentColorSign = /* @__PURE__ */ temporarilyNotSupport('addRecentColorSign')
export const getGuildInfo = /* @__PURE__ */ temporarilyNotSupport('getGuildInfo')
export const applyAddToMyApps = /* @__PURE__ */ temporarilyNotSupport('applyAddToMyApps')
export const isAddedToMyApps = /* @__PURE__ */ temporarilyNotSupport('isAddedToMyApps')
